<template>
  <div class="pc_permiss_user">
    <!-- 搜索 -->
    <div class="pc_select">
      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form
              :inline="true"
              :model="selectForm"
              class="demo-form-inline"
              @submit.native.prevent
            >
              <el-form-item label="">
                <el-input
                clearable
                  v-model="selectForm.keyword"
                  placeholder="请输入用户名或昵称"
                  @clear="handleClear"
                  @keyup.enter.native='onSelect'
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSelect">搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">&nbsp;</div></el-col
        >
        <el-col :span="2"></el-col>
      </el-row>
    </div>
    <!-- 表格区域 -->
    <el-table
      :data="getTabeData"
      border
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column
        fixed
        prop="user_id"
        label="用户名"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="nick"
        label="用户昵称"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="学校"
        label="手机号码"
        width="160"
      ></el-table-column>
      <el-table-column prop="reg_time" label="注册时间"> </el-table-column>
      <el-table-column fixed="right" label="当前状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.defunct === 'N'">开放</el-tag>
          <el-tag type="warning" v-if="scope.row.defunct === 'Y'">屏蔽</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="点击修改用户状态"
            placement="top"
          >
            <el-button
              type="danger"
              icon="el-icon-refresh"
              size="small"
              @click="handleClick(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              type="success"
              icon="el-icon-edit"
              size="small"
              @click="handleEditor(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pc_pages">
      <div class="block">
        <!-- <span class='demonstration'>完整功能</span> -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="sizes"
          :page-size="sizePage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
     <!-- 编辑弹出框 -->
    <el-dialog
      title="编辑角色权限"
      :visible.sync="EditorDialogVisible"
      width="40%"
      :lock-scroll="false"
      @closed="closed('editorForm')"
    >
      <el-form
        :label-position="'lift'"
        label-width="100px"
        :model="editorForm"
        :rules="ruleForm"
        ref="editorForm"
      >
        <el-form-item label="用户名" prop="user_id">
          <el-input v-model="editorForm.user_id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="角色列表" prop="rightstr" v-if="EditorDialogVisible">
          <el-select v-model="editorForm.rightstr" placeholder="请选择权限">
            <el-option :label="orderList.val[0]" :value="orderList.key[0]"></el-option>
            <el-option :label="orderList.val[1]" :value="orderList.key[1]"></el-option>
            <el-option :label="orderList.val[2]" :value="orderList.key[2]"></el-option>
            <el-option :label="orderList.val[3]" :value="orderList.key[3]"></el-option>

          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditorDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editorSubmit('editorForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { initUsersList,changeUsersDefunct, initOrderList, addEditorPrivilege } from 'api/post/postApi.js';
import { isOrder } from 'untils/form_validation.js';

export default {
  name: 'pc_cat_two',
  components: {},
  data() {
    return {
      loading: true,
      tableData: [],
      // 分页功能参数
      total: 0,
      sizes: [10, 20, 30, 40],
      sizePage: 10,
      currentPage: 1,
      editorForm:{},
      ruleForm:null,
      orderList:{},
      selectForm: {
        keyword: ''
      },
      EditorDialogVisible:false

    };
  },
  created() {
    // 数据初始化
    this.initData();
  },
  mounted() {},
  // 计算属性
  computed: {
    // 分页控制
    getTabeData: function () {
      const tableData = this.tableData.slice(
        (this.currentPage - 1) * this.sizePage,
        this.currentPage * this.sizePage
      );
      return tableData;
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initUsersList();
      this.tableData = res.data;
      this.total = res.data.length;
      this.loading = false;
    },
    // 分页功能实现
    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 修改状态
    async handleClick(data) {
      let id = data.user_id;
      let infos='拉黑';
      if(data.defunct==='Y'){
        infos='开放';
      }
      const confirmResult = await this.$confirm(
        `此操作将${infos}当前用户, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消修改！');
      }
      const params = { user_id:id };
      const { data: res } = await changeUsersDefunct(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('修改失败！');
      } else {
        this.$message.success('修改成功！');
        this.initData();
      }
    },
    // 编辑用户
    async handleEditor(data){
      const { data:res } = await initOrderList();
      try{
        // 处理数据
        let arrKey = [];
        let arrVal = [];
        for (let i in res.data) {
          arrKey.push(i); //key
          arrVal.push(res.data[i]); //val
        }
        let obj={ key:arrKey,val:arrVal };
        this.orderList=obj;
        this.editorForm=data;
        this.ruleForm=isOrder;
      }catch{

      }
      this.EditorDialogVisible=true;
    },
    // 提交编辑
    editorSubmit(formName){
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await addEditorPrivilege(this.editorForm);
          if (res.status !== 0) {
            this.$message.error('编辑失败！');
          } else {
            this.$message.success('编辑成功！');
            this.initData();
          }
          this.EditorDialogVisible = false;
        } else {
          this.$message.error('表单验证未通过！');
          // 验证未通过，重置表单
          return false;
        }
      });
    },
    closed(formName){
      this.editorForm={ rightstr:'' };
      this.$refs[formName].resetFields();
    },
    // 搜索实现
    async onSelect() {
      const { data: res } = await initUsersList(this.selectForm);
      if (res.status !== 0) {
        this.$message.error('查找失败！');
        return;
      }
      this.$message.success('查找成功！');
      this.tableData = res.data;
      this.total = res.data.length;
    },
    // 搜索清除
    handleClear(){
      // 重新加载数据
      this.initData();
    }
  }
};
</script>

<style scoped>
.pc_pages {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.pc_select {
  width: 100%;
}
.cratebtn {
  float: right;
}
</style>